import {attemptAccess, versionFor, type LibraryState, type StudentAttempt, type AttemptStatus} from "./activity-library";
import {normalizeActivity} from "./normalized-activity";
import {copyReleased} from "./copy-permissions";
import {currentStudentWork, attemptSessionId} from "./activity-continuity";

export const studentWorkStatus = (status: AttemptStatus) => ({
  not_started: "À lancer", in_progress: "En cours", submitted: "En correction",
  reviewed: "En correction", completed: "Corrigé",
})[status];

/** Work launched in a session, followed through correction without separate tabs. */
export function studentDailyWork(state: LibraryState, now = new Date().toISOString()) {
  return currentStudentWork(state).filter(a => {
    if (!attemptSessionId(a) || copyReleased(a)) return false;
    const capabilities = normalizeActivity(versionFor(state, a)).capabilities;
    return capabilities.hasStudentInputs && capabilities.requiresStudentSubmission &&
      (attemptAccess(state, a, now) === "active" || ["submitted", "reviewed", "completed"].includes(a.status));
  });
}

/** The binder contains existing copies, never unstarted free-access assignments. */
export function studentBinder(state: LibraryState) {
  const copies = currentStudentWork(state).filter(copyReleased);
  const themes = new Map<string, {title: string; chapters: Map<string, {title: string; attempts: StudentAttempt[]}>}>();
  for (const a of copies) {
    const v = versionFor(state, a);
    const themeKey = `${v.levelId}/${v.themeId}`;
    if (!themes.has(themeKey)) themes.set(themeKey, {title: v.themeTitle, chapters: new Map()});
    const theme = themes.get(themeKey)!;
    if (!theme.chapters.has(v.chapterId)) theme.chapters.set(v.chapterId, {title: v.chapterTitle, attempts: []});
    theme.chapters.get(v.chapterId)!.attempts.push(a);
  }
  return themes;
}
